




















import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class CellPanel extends Vue {
  @Prop(String) private title!: string;
  @Prop(String) private desc?: string;
  @Prop({ type: Boolean, default: true }) private hasBorder?: boolean;
  @Prop(Object) private value?: object;

  @Emit("callback")
  private callBack() {
    return this.value;
  }
}
